export default (that, isCheckBox) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    type: 'checkbox',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    slots: {
      default: 'opt',
    },
  },
  {
    title: that.$l('form_label_orderGoodsSpecNo') || '产品规格编号',
    field: 'orderGoodsSpecNo',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_identifyGoodsName') || '识别名称',
    field: 'identifyGoodsName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 300,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_materialDesc') || '面料说明',
    field: 'materialDesc',
    headerAlign: 'center',
    align: 'left',
    minWidth: 300,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_productLine') || '所属产品线',
    field: 'v_productLine',
    headerAlign: 'center',
    align: 'center',
    width: 200,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
